import { render } from "./AddAreaLight.vue?vue&type=template&id=0195c394"
import script from "./AddAreaLight.vue?vue&type=script&lang=js"
export * from "./AddAreaLight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__